import React from 'react';
import CustomDropdown from './CustomDropdown';
import CompanySearchDropdown from './CompanySearchDropdown';
import ForeignExchangeDropdown from './ForeignExchangeDropdown';
import CryptoDropdown from './CryptoDropdown';

const SelectionPanel = ({
  unifiedOptions,
  selectedItems,
  pendingSelection,
  onSelectItem,
  onDeleteItem,
  onIntervalSelect,
  onMaturitySelect,
  intervalOptionsMap,
  maturityOptions,
  maturityRef,
  intervalRef,
  onSelectCompany,
  onSelectFx,
  onSelectCrypto
}) => {
  // Separate economics and commodity options
  const economicsOptions = unifiedOptions
    .filter(opt => opt.type === 'economic')
    .map(opt => ({ label: opt.name, value: opt.code }));
  
  const commodityOptions = unifiedOptions
    .filter(opt => opt.type === 'commodity')
    .map(opt => ({ label: opt.name, value: opt.code }));

  return (
    <div>
      {/* Economics Data Section */}
      <div style={{ marginBottom: '15px' }}>
        <CustomDropdown 
          options={economicsOptions}
          onSelect={onSelectItem}
          label="Macro Data:"
        />

        {/* Show interval/maturity selection right below Macro Data when needed */}
        {pendingSelection?.economy && (
          <div style={{
            marginTop: '12px',
            padding: '12px',
            backgroundColor: '#f1f3f4',
            borderRadius: '6px',
            borderLeft: '4px solid #007bff'
          }}>
            <div style={{
              fontSize: '14px',
              fontWeight: '500',
              color: '#007bff',
              marginBottom: '8px'
            }}>
              Please select additional options for {pendingSelection.name}:
            </div>
            
            {pendingSelection.economy === 'TREASURY_YIELD' && (
              <div style={{ marginBottom: '10px' }}>
                <CustomDropdown
                  options={maturityOptions}
                  onSelect={onMaturitySelect}
                  label="Maturity"
                  dropdownRef={maturityRef}
                />
              </div>
            )}
            <CustomDropdown
              options={intervalOptionsMap[pendingSelection.economy]}
              onSelect={onIntervalSelect}
              label="Interval"
              dropdownRef={intervalRef}
            />
          </div>
        )}
      </div>

      {/* Commodity Data Section */}
      <div style={{ marginBottom: '15px' }}>
        <CustomDropdown 
          options={commodityOptions}
          onSelect={onSelectItem}
          label="Commodities:"
        />
      </div>

      {/* Companies Section */}
      <div style={{ marginBottom: '15px' }}>
        <CompanySearchDropdown 
          onSelect={onSelectCompany}
          label="Stocks:"
        />
      </div>

      {/* Foreign Exchange Section */}
      <div style={{ marginBottom: '15px' }}>
        <ForeignExchangeDropdown 
          onSelect={onSelectFx}
          label="Currencies:"
        />
      </div>

      {/* Crypto Section */}
      <div style={{ marginBottom: '15px' }}>
        <CryptoDropdown 
          onSelect={onSelectCrypto}
          label="Cryptos:"
        />
      </div>

      <div style={{ marginTop: '15px' }}>
        <div style={{ 
          display: 'flex', 
          flexWrap: 'wrap', 
          gap: '8px',
          alignItems: 'center'
        }}>
          {selectedItems.map((item, idx) => (
            <div 
              key={idx} 
              style={{ 
                display: 'inline-flex',
                alignItems: 'center',
                backgroundColor: '#f0f8ff',
                border: '1px solid #cce7f0',
                borderRadius: '20px',
                padding: '6px 12px',
                fontSize: '14px',
                maxWidth: '100%',
                wordBreak: 'break-word'
              }}
            >
              <span style={{ marginRight: '8px' }}>
                {item.name}
                {item.interval && ` (${item.interval})`}
                {item.maturity && ` (${item.maturity})`}
              </span>
              <button 
                onClick={() => onDeleteItem(idx)} 
                style={{ 
                  background: 'none',
                  border: 'none',
                  color: '#007bff',
                  cursor: 'pointer',
                  fontSize: '16px',
                  padding: '0',
                  minWidth: '20px',
                  minHeight: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                title="Remove item"
              >
                ×
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SelectionPanel;
